import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  isUploading: false,
}

const mutations = {
  setUploading: (state, status) => {
    state.isUploading = !!status;
  }
}

export default createCrudModule({
  client: api.client,
  resource: 'data_imports',
  only: [ 'FETCH_SINGLE', 'CREATE' ],
  urlRoot: '/data_imports',
  parseSingle: res => res.data,
  state,
  mutations
});